'use client'

import Link from 'next/link'
import config from '../../data/site-config.json'
import { trackPhoneClick } from '../../lib/analytics'
import AvailabilityBadge from '../common/AvailabilityBadge'

export default function MobileStickyBar() {
    return (
        <div className="show-mobile" style={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            background: 'var(--primary-dark)',
            padding: '0.7rem var(--spacing-sm)',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.4rem',
            zIndex: 1000,
            boxShadow: '0 -4px 16px rgba(0,0,0,0.25)'
        }}>
            <div style={{ display: 'flex', gap: '0.5rem' }}>
                <Link
                    href="/quote"
                    style={{
                        flex: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '0.5rem',
                        background: 'var(--secondary)',
                        color: 'var(--gray-900)',
                        padding: '0.75rem',
                        borderRadius: 'var(--border-radius)',
                        fontWeight: 700,
                        fontSize: '0.95rem',
                        textDecoration: 'none',
                        boxShadow: 'var(--shadow-md)'
                    }}
                >
                    💰 Get Quote
                </Link>
                <Link
                    href={`tel:${config.business.phone}`}
                    onClick={() => trackPhoneClick('mobile_sticky_bar')}
                    style={{
                        flex: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '0.5rem',
                        background: 'white',
                        color: 'var(--primary)',
                        padding: '0.75rem',
                        borderRadius: 'var(--border-radius)',
                        fontWeight: 700,
                        fontSize: '0.95rem',
                        textDecoration: 'none',
                        boxShadow: 'var(--shadow-md)'
                    }}
                >
                    📞 Call Now
                </Link>
            </div>
            <div style={{ textAlign: 'center' }}>
                <AvailabilityBadge size="sm" />
            </div>
        </div>
    )
}
